<template>
  <base-section id="about-our-product">
    <base-section-heading
      color="grey lighten-2"
      icon="mdi-flag"
      title="About Flag FMS"
    />

    <v-container>
      <v-row>
        <v-col
          v-for="card in cards"
          :key="card.title"
          cols="12"
          md="4"
        >
          <base-info-card v-bind="card" />
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>

  export default {
    name: 'SectionAboutOurProduct',

    data: () => ({
      cards: [
        {
          title: '원격 스마트 관리',
          subtitle: '비대면 비접촉 실시간 관리',
          html: '업무용 스마트폰만 있으면 작업 입력 끝!<br>서비스 전용 어플리케이션으로 점검 설비에 부착되어 있는 태그에 태깅하고 점검결과를 입력하기만 하면 실시간으로 설비관리가 완료됩니다.',
          callout: '01',
        },
        {
          title: '디지털 DB Cloud 서비스',
          subtitle: '점검 이력의 자동 전산화',
          html: '현장 작업자가 입력한 점검정보가 실시간으로 클라우드 서버에 등록!<br>해외에서도, 원격지에서도 나의 자산을 리얼타임으로 확인할 수 있는 최첨단 디지털 전자 서비스를 경험하세요.',
          callout: '02',
        },
        {
          title: '경제적 사용료',
          subtitle: '저렴한 관리 솔루션',
          html: '기본 사용료 없이 점검이 필요한 장비 단위로 적용되는 저렴한 관리 비용으로 최첨단 솔루션을 경험하세요!<br>비싼 등록비, 셋팅비 걱정 없이 관리가 필요한 장비만큼만 사용료를 납부하는 합리적 솔루션을 제공해드립니다.',
          callout: '03',
        },
      ],
    }),
  }
</script>
